import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

export const CGV = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-sand-50">
      <div className="bg-white border-b border-sand-200 px-6 py-4 sticky top-0 z-10">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-xl font-serif text-sage-700">Conditions Générales de Vente</h1>
        </div>
      </div>

      <div className="px-6 py-8 max-w-2xl mx-auto prose prose-sage">
        <p className="text-sm text-sage-500">Dernière mise à jour : Juin 2026</p>

        <h2>Article 1 - Objet</h2>
        <p>
          Les présentes Conditions Générales de Vente (CGV) régissent la vente du programme numérique 
          "Déclic RePas" proposé par Lynda Bry-Bonnard (ci-après "le Vendeur") à toute personne 
          effectuant un achat (ci-après "le Client").
        </p>

        <h2>Article 2 - Produit</h2>
        <p>
          Le programme "Déclic RePas" est un produit numérique comprenant :
        </p>
        <ul>
          <li>22 séances audio d'hypnose (modes Zen et Mouvement)</li>
          <li>10 leviers comportementaux (contenu textuel)</li>
          <li>Des outils pratiques interactifs</li>
          <li>Un journal de bord</li>
          <li>Les audios téléchargeables hors connexion</li>
          <li>Un accès illimité aux mises à jour futures du programme</li>
        </ul>

        <h2>Article 3 - Offres et prix</h2>
        <p>
          Le Vendeur propose les offres suivantes :
        </p>
        <ul>
          <li><strong>Accès complet</strong> : 39 € TTC — paiement unique, accès à vie à l'ensemble du programme.</li>
          <li><strong>Accompagnement</strong> : 190 € TTC — accès complet au programme + 2 séances individuelles avec Lynda Bry-Bonnard (en cabinet ou en visio).</li>
        </ul>
        <p>
          Le Vendeur se réserve le droit de modifier ses prix à tout moment, étant entendu que le prix 
          applicable est celui en vigueur au moment de la validation de la commande.
        </p>

        <h2>Article 4 - Commande et paiement</h2>
        <p>
          La commande est validée après paiement intégral du prix ou, en cas de paiement fractionné, 
          après validation de la première échéance. Le paiement s'effectue par carte bancaire via la 
          plateforme sécurisée Stripe. Un email de confirmation est envoyé au Client après validation du paiement.
        </p>

        <h2>Article 4 bis - Paiement fractionné</h2>
        <p>
          Le Client peut choisir de régler son achat en plusieurs fois via le service Klarna, 
          proposé au moment du paiement sur Stripe Checkout. Les options disponibles (paiement en 3 ou 4 fois 
          sans frais) dépendent de l'éligibilité du Client évaluée par Klarna.
        </p>
        <p>
          En cas de paiement fractionné :
        </p>
        <ul>
          <li>L'accès au programme est accordé dès la validation de la première échéance.</li>
          <li>Le Client s'engage à honorer l'ensemble des échéances prévues.</li>
          <li>En cas de défaut de paiement d'une échéance, Klarna applique ses propres conditions 
          de recouvrement. Le Vendeur se réserve le droit de suspendre l'accès au programme en cas 
          d'impayé signalé par Klarna.</li>
          <li>Le paiement fractionné est géré intégralement par Klarna. Le Vendeur n'est pas partie 
          au contrat de crédit entre le Client et Klarna.</li>
        </ul>

        <h2>Article 5 - Accès au programme</h2>
        <p>
          Après paiement, le Client reçoit un code d'accès personnel lui permettant de créer son compte 
          et d'accéder immédiatement à l'intégralité du programme. Cet accès est personnel et ne peut 
          être partagé.
        </p>
        <p>
          Pour l'offre Accompagnement, le Client peut réserver ses 2 séances individuelles en contactant 
          directement le Vendeur par email après activation de son accès.
        </p>

        <h2>Article 6 - Droit de rétractation</h2>
        <p>
          Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne peut 
          être exercé pour les contrats de fourniture de contenu numérique non fourni sur un support 
          matériel dont l'exécution a commencé après accord préalable exprès du consommateur et 
          renoncement exprès à son droit de rétractation.
        </p>
        <p>
          <strong>En validant son achat, le Client reconnaît avoir été informé de cette disposition et 
          y consent expressément.</strong>
        </p>

        <h2>Article 7 - Responsabilité</h2>
        <p>
          Le programme "Déclic RePas" ne se substitue en aucun cas à un suivi médical ou psychologique. 
          Le Vendeur ne saurait être tenu responsable de l'utilisation faite du programme par le Client 
          ni des résultats obtenus.
        </p>

        <h2>Article 8 - Propriété intellectuelle</h2>
        <p>
          L'ensemble du contenu du programme (textes, audios, images) est protégé par le droit d'auteur. 
          Toute reproduction, diffusion ou revente est strictement interdite.
        </p>

        <h2>Article 9 - Données personnelles</h2>
        <p>
          Les données personnelles collectées sont traitées conformément à notre Politique de confidentialité.
        </p>

        <h2>Article 10 - Droit applicable</h2>
        <p>
          Les présentes CGV sont soumises au droit français. En cas de litige, les tribunaux français 
          seront seuls compétents.
        </p>

        <h2>Contact</h2>
        <p>
          Pour toute question relative aux présentes CGV : brylynda@gmail.com
        </p>
      </div>
    </div>
  );
};

export default CGV;
